import logo from "./logo.svg";
import "./App.css";
import MainRoutes from "./app/routes/routes";
import { Flex } from "@chakra-ui/react";

function App() {
  return (
    <Flex direction="column" flex="1" bg="bg-canvas">
      <Flex as="main" role="main" direction="column" flex="1">
        <MainRoutes />
      </Flex>
    </Flex>
  );
}

export default App;
